module.exports = __webpack_public_path__ + "static/media/video.0695c6ac.svg";